import { render, staticRenderFns } from "./ProjectRoleView.vue?vue&type=template&id=a61e39d2&scoped=true"
import script from "./ProjectRoleView.vue?vue&type=script&lang=js"
export * from "./ProjectRoleView.vue?vue&type=script&lang=js"
import style0 from "./ProjectRoleView.vue?vue&type=style&index=0&id=a61e39d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61e39d2",
  null
  
)

export default component.exports